const destinationAssets = [
  {
    name: 'aspen',
    title: 'Aspen',
    mainAsset: {
      path: getMainAssetPath('aspen'),
      positionX: '',
      positionY: ''
    },
    assets: [
      'madrid/rolex-16-9',
      'madrid/dolce-gabbana-16-9',
      'madrid/salvatore-ferragamo-16-9',
      'madrid/hublot-16-9',
      'madrid/gucci-16-9'
    ]
  },
  {
    name: 'beverly-hills',
    title: 'Beverly Hills',
    mainAsset: {
      path: getMainAssetPath('beverly-hills'),
      positionX: 'right',
      positionY: 'center'
    },
    assets: [
      'beverly-hills/burberry-16-9',
      'beverly-hills/cartier-16-9',
      'beverly-hills/dolce-gabbana-16-9',
      'beverly-hills/tiffany-16-9',
      'beverly-hills/gucci-16-9'
    ]
  },
  {
    name: 'madrid',
    title: 'Madrid',
    mainAsset: {
      path: getMainAssetPath('madrid'),
      positionX: 'center',
      positionY: 'center'
    },
    assets: [
      'madrid/rolex-16-9',
      'madrid/dolce-gabbana-16-9',
      'madrid/salvatore-ferragamo-16-9',
      'madrid/hublot-16-9',
      'madrid/gucci-16-9'
    ]
  },
  {
    name: 'milan',
    title: 'Milan',
    mainAsset: {
      path: getMainAssetPath('milan'),
      positionX: '',
      positionY: 'center'
    },
    assets: [
      'milan/tiffanys-16-9',
      'milan/rolex-16-9',
      'milan/luxury-hotel-16-9',
      'milan/salvatore-ferragamo-16-9',
      'milan/dolce-gabbna-16-9'
    ]
  },
  {
    name: 'new-york',
    title: 'New York',
    mainAsset: {
      path: getMainAssetPath('new-york'),
      positionX: 'center',
      positionY: 'center'
    },
    assets: [
      'new-york/tiffany-16-9',
      'new-york/rolex-16-9',
      'new-york/cartier-16-9',
      'new-york/bvlgari-16-9',
      'new-york/gucci-16-9'
    ]
  },
  {
    name: 'saint-tropez',
    title: 'St. Tropez',
    mainAsset: {
      path: getMainAssetPath('saint-tropez'),
      positionX: 'center',
      positionY: ''
    },
    assets: [
      'saint-tropez/bvlgari-16-9',
      'saint-tropez/chanel-16-9',
      'saint-tropez/hublot-16-9',
      'saint-tropez/gucci-16-9',
      'saint-tropez/rolex-16-9'
    ]
  }
];


export function getMainAssetPath(location) {
  return `https://${process.env.VUE_APP_BASE_URL}/static-assets/destinations/${location}/main.jpg`;
}

export function getDestinationMainAsset(destination) {
  return destinationAssets.find((e) => e.name === destination).mainAsset.path
}

export function getDestinationAssets(destination) {
  return destinationAssets.find((e) => e.name === destination)
}